enum RoutesEnum {
  HOME = "/",
  DATABASES = "/db", // New route for databases
  SEARCH = "/search", // New route for the search page
  ABOUT = "/about", // New route for the about page
  DASHBOARD = "/dashboard",
  BIDS_CONVERTER = "/autobidsify",
  UPLOAD = "/upload", // logged-in users submit a JSON dataset for review
}
export default RoutesEnum;
